/**
 * Demo stub for `modules/Auth/AuthProvider/forceLogout`.
 *
 * In the real app, a 401 from collectiveApi → forceLogoutRedirect →
 * window.location.href = config.frontendURL + 'login'. That nukes the demo back to the
 * prod login page. The demo runs with MSW intercepting every request, so a 401 should
 * never reach the response interceptor — but if one slips through (timing, an MSW
 * unhandled-request fallback, etc.) we don't want to bounce the visitor off the demo.
 */
// eslint-disable-next-line import/prefer-default-export
export function forceLogoutRedirect(): void {
    // eslint-disable-next-line no-console
    console.warn('[demo] forceLogoutRedirect called — suppressed in demo mode.');
}
